import React from "react";

const Result = ({ userAnswers, examQuestions, timeTaken }) => {
  const correctAnswers = userAnswers.filter(
    (answer) =>
      answer.answer ===
      examQuestions.find((q) => q.id === answer.questionId).correct
  ).length;

  const isPassed = correctAnswers >= 18;
  const totalUserQuestions = userAnswers.length;
  const incorrectAnswers = totalUserQuestions - correctAnswers;

  // Formatowanie czasu na minuty i sekundy
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes} min ${seconds} s`;
  };

  return (
    <div className="result">
      <div className={`result__status ${isPassed ? "passed" : "failed"}`}>
        {isPassed ? "Egzamin zdany!" : "Egzamin niezdany"}
      </div>
      <div className="result__summary">
        <p>Poprawne odpowiedzi: {correctAnswers}</p>
        <p>Błędne odpowiedzi: {incorrectAnswers}</p>
        <p>Czas egzaminu: {formatTime(timeTaken)}</p>{" "}
        {/* Dodajemy czas trwania egzaminu */}
      </div>

      <ul className="result__questions-list">
        {userAnswers.map((userAnswer) => {
          const question = examQuestions.find(
            (q) => q.id === userAnswer.questionId
          );
          const isCorrect = userAnswer.answer === question.correct;

          return (
            <li key={question.id} className="result__question-item">
              <h3 className="result__question">
                {question.id}. {question.question}
              </h3>
              <ul className="result__answers">
                {Object.entries(question.answers).map(([key, answer]) => (
                  <li
                    key={key}
                    className={`result__answer-item ${
                      key === userAnswer.answer
                        ? isCorrect
                          ? "user-correct"
                          : "user-incorrect"
                        : key === question.correct
                        ? "correct-answer"
                        : "incorrect-answer"
                    }`}
                  >
                    <span className="result__marker">
                      {key === userAnswer.answer
                        ? isCorrect
                          ? "✔️"
                          : "❌"
                        : ""}
                    </span>
                    {key.toUpperCase()}. {answer}
                  </li>
                ))}
              </ul>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Result;
